import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollTrigger,ScrollSmoother);

const gScrubSpeed = 500;

async function videoScrub(video, loader, loaderWrap, overlay, vars) {
    video = gsap.utils.toArray(video)[0]; // in case selector text is fed in.
    let once = (el, event, fn) => {
        let onceFn = function () {
            el.removeEventListener(event, onceFn);
            fn.apply(this, arguments);
        };
        el.addEventListener(event, onceFn);
        return onceFn;
    };
    let prepFunc = () => {
        video.play();
        video.pause();
    };
    let prep = () => once(document.documentElement, "touchstart", prepFunc);
    return new Promise(resolve => {
        video.addEventListener('loadedmetadata', () => {
            let tween = gsap.fromTo(
                video,
                {currentTime: 0},
                {
                    paused: true,
                    immediateRender: false,
                    currentTime: video.duration || 1,
                    ease: "none",
                    ...vars
                }
            );
            let resetTime = () => {
                (tween.vars.currentTime = video.duration || 1) && tween.invalidate();
                //let calculatedPinHeight = (video.duration * gScrubSpeed);
                //video.setAttribute('data-scrub-height', calculatedPinHeight.toString());
                loader.stop();
                loaderWrap.style.display = 'none';
                gsap.to(overlay, { opacity: 0, duration: 2, ease: 'power1.out' });
                ScrollTrigger.refresh();
            };
            prep();
            video.readyState ? resetTime() : once(video, "loadedmetadata", resetTime);
            resolve(tween);
        });
    })
}

// Changed this value for now to make the scrub work on mobile
const mobileBreakpoint = 0;
const scrubBreakpoint = 10;

function isScrubEnabled() {
    return window.innerWidth >= scrubBreakpoint;
}

function getVideoSrc(video) {
    return window.innerWidth < mobileBreakpoint
        ? video.dataset.srcMobile
        : video.dataset.srcDesktop;
}

const isScrubVideoMobile = window.innerWidth < mobileBreakpoint;
const isScrubCapable     = isScrubEnabled();

async function initNewScrub(video) {
    // Kill previous tween and ScrollTrigger if they exist
    if (video._scrubTween) {
        if (video._scrubTween.scrollTrigger) {
            video._scrubTween.scrollTrigger.kill();
        }
        video._scrubTween.kill();
        video._scrubTween = null;
    }

    video.pause();
    const parentWrapper = video.closest('.js-scrub-banner');
    const overlay = parentWrapper.querySelector('.js-loader-overlay');
    const loaderAnimContainer = parentWrapper.querySelector('.fs-media-wrapper__loader-anim');
    gsap.set([overlay, loaderAnimContainer], { clearProps: 'all' });

    const src = getVideoSrc(video);

    if (src) {
        if (video.querySelector('source')) {
            video.querySelector('source').src = src;
        } else {
            const source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            video.appendChild(source);
        }
    }

    const anim = lottie.loadAnimation({
        container: loaderAnimContainer,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: window.params.assets_path + '/assets/img/uploads/striker_Preloader.json',
        preserveAspectRatio: 'xMidYMid meet' // This will scale down to fit, without cropping
    });
    anim.setSpeed(1.5); // Make a bit faster

    if (isScrubEnabled()) {
        video._scrubTween = await videoScrub(video, anim, loaderAnimContainer, overlay, {
            scrollTrigger: {
                trigger: '.js-scrub-banner',
                start: "center center",
                end: () => "+=" + (video.duration * gScrubSpeed),
                markers: false,
                scrub: true,
                pin: true,
                refreshPriority: 1
            },
        });
    } else {
        // Play video normally
        video.controls = true;
        video.autoplay = true;
        video.loop = true;
        video.controls = false;
        video.muted = true;
        video.style.display = 'block';
        overlay.style.display = 'none';
        loaderAnimContainer.style.display = 'none';
        video.load();
        video.play().catch(err => {
            console.warn("Autoplay blocked by browser:", err.message);
        });
        video.addEventListener('canplay', () => {
            anim.stop();
            loaderAnimContainer.style.display = 'none';
            gsap.to(overlay, { opacity: 0, duration: 2, ease: 'power1.out' });
        }, { once: true });
    }
}


document.addEventListener("DOMContentLoaded", function () {
    gsap.utils.toArray('.js-video-scrub').forEach((video) => initNewScrub(video));

    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            onResize();
        }, 250);
    });

    function onResize() {
        // Only invoke new video reload if scrub is no longer valid or
        // if we have switched from mobile src to desktop src or vice versa

        const newIsScrubCapable = isScrubEnabled();
        const newIsScrubVideoMobile = window.innerWidth < mobileBreakpoint;

        if (newIsScrubCapable !== isScrubCapable || newIsScrubVideoMobile !== isScrubVideoMobile) {
            gsap.utils.toArray('.js-video-scrub').forEach((video) => initNewScrub(video));
        }
    }
});


